var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWowbrothers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 177.1 173.8",
    style: {
      enableBackground: "new 0 0 177.1 173.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.2,68.5V49.7h3.9V35.9l-3.9-2.7V12.5l-8-8h-13.9v2.7l-1.5-2.7H142L138,0h-13.9v4.5h-11.7v4l-3.7-4H94.9v10.9L84.1,4.5 H65.5l-9.4,9.4v3.4L43.3,4.5h-34L0,13.9v20.8l11.9,11.9H0v13.9l8,8h11.5v14.1h1.3v0.6h-9v4.5H0v9.8l4,4h1.3v0.1L0,106.9v18.2 l9.4,9.4l0,0l1.3,1.3l0,0l1.1,1.1l-7.4,7.4v12.1l9.4,9.4l0,0l1.3,1.3l0,0l1.3,1.3l0,0l1.3,1.3l0,0L19,171l0,0l1.3,1.3l0,0l1.3,1.3 h29.6l9.4-9.4v-12.1l-9.4-9.4l0,0l-0.6-0.6h10v-2.7l1.9,2.7h11.8l3.1-11.4l0.9,3.4l8,8h3v23.6l8,8h19.6v-4l3.5,4h52.7v-12.2l-4-3.6 h4v-23.6l-2.7-2.4h2.7v-9.8l-4-2.8h4v-12.2l-2.7-1.7h2.7v-9.8l-5.3-5.1h5.3V76.7l-8.2-8.2H173.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.1,6.4l-8.3,8.3V34l8.3,8.3h32.4l8.3-8.3V14.7l-8.3-8.3C42.5,6.4,10.1,6.4,10.1,6.4z M40.7,32.1H12V16.6 h28.6v15.5H40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.2,6.4l-8.3,8.3v35.7l8.3,8.3h17.1l8.3-8.3V14.7l-8.3-8.3C83.3,6.4,66.2,6.4,66.2,6.4z M81.4,48.5H68.1 V16.6h13.3V48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.7,58.7l8.3-8.3V24.5l-8.3-8.3h-17.1l-8.3,8.3v25.9l8.3,8.3H139.7z M124.6,26.4h13.3v22.1h-13.3 C124.6,48.5,124.6,26.4,124.6,26.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1.8,58.7 21.3,58.7 21.3,80.8 31.5,80.8 31.5,58.7 50.9,58.7 50.9,48.5 1.8,48.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "148,6.4 136.3,6.4 136.3,1.8 126.1,1.8 126.1,6.4 114.3,6.4 114.3,12.5 148,12.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "107,6.4 96.8,6.4 96.8,80.8 107,80.8 107,39.9 110.6,39.9 110.6,29.7 107,29.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "124.6,61.4 114.3,61.4 114.3,80.8 163.4,80.8 163.4,70.6 124.6,70.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "163.4,6.4 153.2,6.4 153.2,58.7 163.4,58.7 163.4,39.9 167.3,39.9 167.3,29.7 163.4,29.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.2,132.7l8.3-8.3v-16.7l-8.3-8.3H10.1l-8.3,8.3v16.7l8.3,8.3H27.2z M12,109.6h13.3v12.9H12V109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.5,136.8l-8.3,8.3v10.6l8.3,8.3h28.1l8.3-8.3v-10.6l-8.3-8.3H14.5z M40.7,153.8H16.4V147h24.3 C40.7,147,40.7,153.8,40.7,153.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "35.5,89.6 23.8,89.6 23.8,85.1 13.6,85.1 13.6,89.6 1.8,89.6 1.8,95.7 35.5,95.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "40.7,99.4 38.4,99.4 38.4,109.6 40.7,109.6 40.7,115.6 38.4,115.6 38.4,125.8 40.7,125.8  40.7,132.5 50.9,132.5 50.9,89.4 40.7,89.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.3,
    y: 116.1,
    className: "st0",
    width: 49.1,
    height: 6.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "114.3,101.1 114.3,105.3 114.3,109.6 163.4,109.6 163.4,101.1 124.5,101.1 124.5,95.7 163.4,95.7  163.4,89.6 114.3,89.6 114.3,95.7 114.3,95.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "163.4,148.2 163.4,146.6 163.4,146.6 163.4,130.6 163.4,130.6 163.4,128.3 114.3,128.3 114.3,136.8  153.2,136.8 153.2,142 114.3,142 114.3,148.2 114.3,148.2 114.3,155.5 114.3,161 114.3,164 163.4,164 163.4,155.5 124.5,155.5  124.5,148.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "87.3,95.7 87.3,89.6 58.1,89.6 58.1,95.7 67.1,95.7 57,132.5 65,132.5 72.4,105.6 79.8,132.5  87.8,132.5 77.6,95.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 89.6,
    className: "st0",
    width: 6.1,
    height: 74.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "91.2,105.1 86.9,105.1 86.9,115.3 91.2,115.3 91.2,164 97.3,164 97.3,89.6 91.2,89.6  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWowbrothers);
export default __webpack_public_path__ + "static/media/wowbrothers.97baf8ba4e288ca40316a60f9da89cb9.svg";
export { ForwardRef as ReactComponent };